var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.99 18.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "filter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "filter",
    d: "M18.25,0H.74A.74.74,0,0,0,0,.74,7.25,7.25,0,0,0,2.43,6.15L5.68,9a2.65,2.65,0,0,1,.89,2v7.24a.74.74,0,0,0,1.15.62L12.1,16a.76.76,0,0,0,.33-.62V11a2.65,2.65,0,0,1,.88-2l3.25-2.89A7.21,7.21,0,0,0,19,.74.74.74,0,0,0,18.25,0ZM15.58,5,12.33,7.93A4.13,4.13,0,0,0,10.94,11v3.92L8.05,16.86V11A4.13,4.13,0,0,0,6.66,7.93L3.42,5A5.71,5.71,0,0,1,1.53,1.48H17.46A5.75,5.75,0,0,1,15.58,5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.b51957245a72dcbf5ebfcedfbe121acc.svg";
export { ForwardRef as ReactComponent };